import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { 
  Rocket, MessageCircle, CreditCard, Package, 
  TrendingUp, Target, Zap, Award 
} from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const QuickActions = ({ onAction }) => {
  const navigate = useNavigate();

  const switchTab = (tabId) => {
    if (typeof onAction === 'function') {
      onAction(tabId);
    } else {
      // Fallback — dispatch a custom event Dashboard listens to
      window.dispatchEvent(new CustomEvent('dashboard:set-tab', { detail: tabId }));
    }
  };

  const actions = [
    { 
      icon: Package, 
      label: 'View Orders', 
      color: 'from-blue-500 to-blue-600',
      onClick: () => switchTab('orders')
    },
    { 
      icon: CreditCard, 
      label: 'Payments', 
      color: 'from-green-500 to-green-600',
      onClick: () => switchTab('payments')
    },
    { 
      icon: TrendingUp, 
      label: 'Analytics', 
      color: 'from-purple-500 to-purple-600',
      onClick: () => switchTab('analytics')
    },
    { 
      icon: Target, 
      label: 'Track Ads', 
      color: 'from-orange-500 to-orange-600',
      onClick: () => switchTab('ads')
    },
    { 
      icon: MessageCircle, 
      label: 'Contact Agent', 
      color: 'from-pink-500 to-pink-600',
      onClick: () => window.open('https://wa.me/918965883955', '_blank')
    },
    { 
      icon: Rocket, 
      label: 'Upgrade Plan', 
      color: 'from-yellow-500 to-yellow-600',
      onClick: () => navigate('/onboarding')
    }
  ];

  return (
    <Card className="bg-white border-slate-200 shadow-sm">
      <CardHeader>
        <CardTitle className="text-lg flex items-center text-slate-800">
          <Zap className="w-5 h-5 mr-2 text-blue-600" />
          Quick Actions
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
          {actions.map((action, index) => {
            const Icon = action.icon;
            return (
              <button
                key={index}
                onClick={action.onClick}
                className={`group relative overflow-hidden bg-gradient-to-br ${action.color} text-white p-4 rounded-xl transition-all shadow-md hover:shadow-lg`}
              >
                <div className="flex flex-col items-center text-center">
                  <Icon className="w-6 h-6 mb-2 group-hover:scale-110 transition-transform" />
                  <span className="text-xs font-medium">{action.label}</span>
                </div>
                <div className="pointer-events-none absolute inset-0 bg-white opacity-0 group-hover:opacity-10 transition-opacity" />
              </button>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};

export default QuickActions;
